import {FaXTwitter} from '../icons/faXTwitter.tsx';
import {FaBluesky} from '../icons/faBluesky.tsx';
import GetLabel from "../language/GetLabel.tsx";
import {getLabel} from "../language/lang-utils.ts";

const SharePageReact = () => {

    const onTwClickHandler = (curLocation: string | Location) => {
        window.open("https://twitter.com/share?url=" + curLocation, "_blank");
    }

    const onSkyClickHandler = (curLocation: string | Location) => {
        window.open("https://bsky.app/intent/compose?text=" + curLocation, "_blank");
    }

    const BlueskyURL = window.location.href.replace("=", "%3D");

    return (
        <div className="share-container" itemScope itemType="https://schema.org/ShareAction">
            <span><GetLabel name="SHARE"/></span>
            <button aria-label={getLabel("SHARE") + " X"} className="shBtns twBtn" onClick={() => onTwClickHandler(window.location.href)} itemProp="potentialAction"><FaXTwitter/> </button>
            <button aria-label={getLabel("SHARE") + " Bluesky"} className="shBtns skyBtn" onClick={() => onSkyClickHandler(BlueskyURL)} itemProp="potentialAction"><FaBluesky/> </button>
        </div>
    )
}

export default SharePageReact;